import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import translation from "~/i18n";

// Assets
import "~/assets/sass/pages/invest/evaluateList.scss";
import darkImgLogo from "~/assets/img/defaultImg/dark-logo-square.png";
import lightImgLogo from "~/assets/img/defaultImg/light-logo-square.png";
import InitialView from "./contents/InitialView";
import currentStatus from "../util/utilForDetail";
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import Checkbox from "~/common/components/Checkbox";
import LoadingPage from "~/pages/LoadingPage";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";

const searchOption = [
	{ label: translation.t("pages.investment.InvestEvalPage.list.list.label01"), value: "ALL" },
	{
		label: translation.t("pages.investment.InvestEvalPage.list.list.label02"),
		value: "승인대기",
	},
	{ label: translation.t("pages.investment.InvestEvalPage.list.list.label03"), value: "승인" },
	{ label: translation.t("pages.investment.InvestEvalPage.list.list.label04"), value: "반려" },
	{ label: translation.t("pages.investment.InvestEvalPage.list.list.label05"), value: "완료" },
];

const List = ({ listData, handleDetail, doSearch, loadingPage, setSearchStatus }) => {
	const [
		{
			theme: { theme },
			sidebar: { currentPath },
		},
	] = useGlobalStore();

	const { t } = useTranslation();
	const evalSearchForm = useForm();

	const selectStatus = evalSearchForm.watch("judgeProgress");
	const searchInput = evalSearchForm.watch("searchList");

	const [validate, setValidate] = useState(false);
	const [isAllChecked, setIsAllCheck] = useState(true);

	const [showAuthAlert, AuthAlert] = useAlert();

	const ref = useRef();

	const checkIntersect = ([entry], observer) => {
		/** 상태 스크롤 조회 **/
		setSearchStatus(true);

		if (entry.isIntersecting) {
			setFormData((prevState) => ({
				...prevState,
				page: prevState.page + 1,
			}));
		}
	};

	const [load, setLoad] = useState(false);

	const [formData, setFormData] = useState({
		companyName: "",
		status: ["승인대기", "승인", "반려", "완료"],
		page: 1,
		size: 12,
	});

	useEffect(() => {
		if (!load) {
			doSearch(
				{
					companyName: "",
					status: ["승인대기", "승인", "반려", "완료"],
					page: 1,
					size: 12,
				},
				() => {
					setLoad(true);

					let observer = new IntersectionObserver(checkIntersect, {
						root: null,
						threshold: 0,
						rootMargin: "0px",
					});

					observer.observe(ref.current);
					return () => observer && observer.disconnect();
				}
			);
		}
	}, []);

	useEffect(() => {
		if (load) {
			doSearch(formData);
		}
	}, [formData]);

	const searchList = () => {
		if (selectStatus && selectStatus.length > 0) {
			/** 상태 버튼 조회 **/
			setSearchStatus(false);
			setValidate(false);

			setFormData({
				companyName: searchInput === undefined ? "" : searchInput,
				status: selectStatus.filter((list) => list !== "ALL"),
				page: 1,
				size: 12,
			});
		} else {
			setValidate(true);
		}
	};

	useEffect(() => {
		if (selectStatus && selectStatus.length > 0) {
			setValidate(false);
		}
	}, [selectStatus]);

	return (
		<div className="list-wrap">
			<div className="c__card eval-search-wrap">
				<Form useForm={evalSearchForm}>
					<Checkbox
						label={t("pages.investment.InvestEvalPage.list.list.form.label01")}
						name="judgeProgress"
						className="status-chk-wrap"
						options={searchOption}
						validate={validate}
						isAllChecked={isAllChecked}
						setAllSelected={setIsAllCheck}
					/>
					<Group
						label={t("pages.investment.InvestEvalPage.list.list.form.label02")}
						className="search-list-wrap"
					>
						<Input
							name="searchList"
							placeholder={t(
								"pages.investment.InvestEvalPage.list.list.form.placeholder"
							)}
							onEnter={() => searchList()}
						/>
						<button
							type="button"
							className="btn__solid btn-search"
							color="primary"
							onClick={() => searchList()}
						>
							{t("pages.investment.InvestEvalPage.list.list.form.search")}
						</button>
					</Group>
				</Form>
				<p className="warning-phrase">
					{t("pages.investment.InvestEvalPage.list.list.warning")}
				</p>
			</div>

			{!loadingPage ? (
				<div className="c__cardRow">
					{listData.length !== 0 ? (
						listData?.map((d) => {
							return (
								<>
									<div
										className="c__card invest-card"
										key={d.idx}
										onClick={() => {
											if (currentPath.auth !== "edit") {
												showAuthAlert();
												return;
											}
											handleDetail(d.idx);
										}}
									>
										<div className="top">
											<div className="img-wrap">
												<img
													src={
														d.StartupCompany.logoSqu ||
														(theme === "dark"
															? darkImgLogo
															: lightImgLogo)
													}
													alt={t(
														"pages.investment.InvestEvalPage.list.list.imageAlt"
													)}
												/>
											</div>
											<dl className="company">
												<dt className="name">{d.StartupCompany.name}</dt>
												<dt className="ceo">{d.StartupCompany.ceoName}</dt>
											</dl>
										</div>
										<p className="content">
											{d.title}
											<br />
											{d.content}
										</p>
										<p className="date">{d.regDate.substring(0, 10)}</p>
										<ol className={`custom-step ${currentStatus(d.status)}`}>
											<li className="step-waiting">
												{t(
													"pages.investment.InvestEvalPage.list.list.label02"
												)}
											</li>
											<li
												className={`step-evaluate ${
													currentStatus(d.status) === "rejection"
														? "reject"
														: ""
												}`}
											>
												{currentStatus(d.status) === "rejection"
													? t(
															"pages.investment.InvestEvalPage.list.list.label04"
													  )
													: t(
															"pages.investment.InvestEvalPage.list.list.label03"
													  )}
											</li>
											<li className="step-complete">
												{t(
													"pages.investment.InvestEvalPage.list.list.label05"
												)}
											</li>
										</ol>
									</div>
								</>
							);
						})
					) : (
						<InitialView />
					)}
				</div>
			) : (
				<LoadingPage />
			)}

			{/*//---- Empty*/}
			{/*<div className="page-init">*/}
			{/*	<p className="main">투자 심사 내역을 찾을 수 없습니다.</p>*/}
			{/*	<p className="sub">*/}
			{/*		투자기업 검색에서 원하는 스타트업에 투자심사 요청을 해보세요.*/}
			{/*	</p>*/}
			{/*<img src={darkInitImg} alt="초기이미지" />*/}
			{/*<img src={lightInitImg} alt="초기이미지" />*/}
			{/*</div>*/}
			<div ref={ref}></div>
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</div>
	);
};

export default List;
